import { Field, InputType } from 'type-graphql'
import { ViewCountKeyEnum } from '../ViewCountKeyEnum'

/**
 * Input arguments for getting view count.
 * Used in the viewCount GraphQL query.
 */
@InputType()
export class GetViewCountArgs {
  @Field(() => ViewCountKeyEnum, { description: 'The entity type (Order, PurchaseOrder, etc.)' })
  key: ViewCountKeyEnum

  @Field(() => String, { description: 'The entity ID' })
  value: string
}
